import {
	getConversationEmitter,
	updateConversationTextSizeCommandUpdateEmitter,
	createNormalReplayConversationEmitter,
	createQuickPathConversationEmitter,
	createSmartReplyConversationEmitter,
	closeConversationEmitter,
	gradeConversationScoreEmitter,
	clearConversationSessionEmitter,
} from './conversation-emitters';

import {
	getConversationRepliesEmitter,
	sendTextConversationReplyEmitter,
	createConversationTagEmitter,
	createConversationFormReplyEmitter,
	sendTypingConversationReplyEmitter,
	selectConversationOptionEmitter,
	resetConversationSmartReplyEmitter,
	contactCSConversationEmitter,
	createConversationQAformEmitter,
	createConversationQAChargeformEmitter,
} from './conversation-reply-emitters';

import {
	forceConnectSocketEmitter,
	forceDisconnectSocketEmitter,
	forceReconnectSocketEmitter,
} from './application-emitter';

export default [
	// Conversation
	getConversationEmitter,
	updateConversationTextSizeCommandUpdateEmitter,
	createNormalReplayConversationEmitter,
	createQuickPathConversationEmitter,
	createSmartReplyConversationEmitter,
	sendTypingConversationReplyEmitter,
	closeConversationEmitter,
	gradeConversationScoreEmitter,
	clearConversationSessionEmitter,
	// Conversation Reply
	getConversationRepliesEmitter,
	sendTextConversationReplyEmitter,
	createConversationTagEmitter,
	createConversationFormReplyEmitter,
	selectConversationOptionEmitter,
	resetConversationSmartReplyEmitter,
	contactCSConversationEmitter,
	createConversationQAformEmitter,
	createConversationQAChargeformEmitter,
	// Application
	forceConnectSocketEmitter,
	forceDisconnectSocketEmitter,
	forceReconnectSocketEmitter,
];
